"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfiguration = exports.configurationContext = exports.ConfigurationProvider = void 0;
var _react = require("react");
var _enums = require("../models/olapic/enums");
/* istanbul ignore file @preserve --context */

const configurationContext = exports.configurationContext = /*#__PURE__*/(0, _react.createContext)({
  categoryId: '',
  productCode: '',
  type: _enums.OlapicTypeEnum.FrontPage
});
const ConfigurationProvider = exports.ConfigurationProvider = configurationContext.Provider;
const useConfiguration = () => (0, _react.useContext)(configurationContext);
exports.useConfiguration = useConfiguration;
